import React, {Fragment, useContext} from "react";
import {CustomerTypeContext, isCustomerCompany} from "../../context/customer-type-context";

function StepForCustomerType({onNextClick}) {

    const customerContext = useContext(CustomerTypeContext);
    const [currentCustomerType, setCustomerType, availableCustomerTypes] = customerContext;

    const companyClickHandler = () => setCustomerType(availableCustomerTypes.company);
    const personClickHandler = () => setCustomerType(availableCustomerTypes.person);

    const isCompany = isCustomerCompany(customerContext);

    const toggleHandler = () => isCompany ? personClickHandler() : companyClickHandler();

    return (
        <Fragment>

            <div className="config-modal-body">

                <h5 className="center">Prowadzisz firmę czy jesteś konsumentem (osoba fizyczna)?</h5>

                <div className="customer-type-toggle">
                    <span className={"toggle-label" + (isCompany ? " toggle-label--active" : "")}>Firma</span>
                    <button type="button" className={"toggle-switch" + (isCompany ? " toggle-switch--left" : " toggle-switch--right")} onClick={toggleHandler}>
                        <span className="toggle-thumb"></span>
                    </button>
                    <span className={"toggle-label" + (!isCompany ? " toggle-label--active" : "")}>Konsument</span>
                </div>

            </div>

            <div className="config-modal-footer">

                <div className="flex">
                    <button type="button" className="lastButton" onClick={onNextClick}>
                        Dalej <i className="fa fa-angle-right"></i>
                    </button>
                </div>

            </div>
        </Fragment>
    );
}

export default StepForCustomerType;